
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10958_11312)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"14","height":"14"}},[_c('path',{attrs:{"d":"M14 0H0v14h14V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M7.543 11.445l-.78-3.72c-.07-.333-.178-.332-.24.002L5.81 11.46a.665.665 0 01-.478.487l-3.72.78c-.333.07-.49-.125-.35-.435L6.407.871c.093-.206.247-.208.344-.003l5.355 11.325c.145.307-.008.505-.342.44l-3.734-.71a.665.665 0 01-.487-.478z","fill":"#fff"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10958_11312"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    